import { Button, Flex } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import { StateTemplate } from "./StateTemplate";

export type ErrorStateProps = {
  onExit: () => void;
  onRetry: () => void;
  errorMessage?: string;
};

export const ErrorState = ({ onExit, onRetry, errorMessage }: ErrorStateProps) => {
  return (
    <StateTemplate
      title="Something went wrong"
      subTitle={errorMessage ?? "Please try again or go back to the queue."}
      icon={<Icon type="exclamation-circle" color={Colors.Danger600} size="xx-large" />}
    >
      <Flex gap={SPACING.SMALL}>
        <Button variant="neutral" onClick={onExit} data-testid="ddq-wizard-error-state-exit">
          Back to queue
        </Button>
        <Button onClick={onRetry} data-testid="ddq-wizard-error-state-retry">
          Try again
        </Button>
      </Flex>
    </StateTemplate>
  );
};
